import { CircularProgress } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';

export default function Loader({ sx, fullScreen, ...other }: BoxProps & { fullScreen?: boolean }) {
  return (
    <Box
      sx={{
        px: 5,
        width: '100%',
        flex: 1,
        height: fullScreen ? '100vh' : '100%',
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
      {...other}
    >
      <CircularProgress sx={{ width: 1, maxWidth: 360 }} />
    </Box>
  );
}
